<template>
  <Transition name="fade" appear>
    <div class="dropdown" v-if="show">
      <div class="dialog-content">
        <slot></slot>
      </div>
    </div>
  </Transition>
</template>


<script>
import {ref} from 'vue'

export default{
  name:'my-dropdown',
  props:['show'],
}
</script>


<style scoped>
.dropdown{
  transition: 0.1s ease-out;
}

.dialog-content{

}

.fade-enter-active, 
.fade-leave-active {
  opacity: 0;
  transition: opacity 0.1s;
}

.fade-enter, 
.fade-leave-to {
  opacity: 0;
}
</style>
